export default "__VITE_ASSET__Dnkvrx83__"